const EventsArray2023 = [


    
 

    {
        venue: 'IIT Tirupati',
        link: "https://sites.google.com/iittp.ac.in/ats-functional-analysis/home",
        title: `Advanced Training School on Functional Analysis and Its Applications for Research Scholars and Teachers`,
        description: 'Founded by National Board for Higher Mathematics (NBHM), Department of Atomic Energy, Government of India',
        img: 'https://files.iittp.ac.in/images/events/ATS2023.png',
        dt: "11 - 22",
        my: "Dec",
        glow: "no",
        duration: '11 days',
    },

    {
        venue: 'IIT Tirupati',
        link: "https://files.iittp.ac.in/pdfs/events/2023/Workshop_on%20_Wastewater.pdf",
        title: `Workshop on "Sustainable Wastewater Management: The Role of Advanced Treatment and Sensing Technologies"`,
        description: 'The Indian Institute of Technology Tirupati (IIT Tirupati), established in 2015, is an autonomous Institute under Ministry of Education, Government of India.The Government of Andhra Pradesh is nurturing Tirupati as knowledge hub of the State.',
        img: 'https://files.iittp.ac.in/images/events/Wastewater2023.png',
        dt: "1 - 2",
        my: "Dec",
        glow:"no",
        duration: '2 days',
    },
    


    // {
        // venue: 'IIT Tirupati',
    //     link: "https://files.iittp.ac.in/pdfs/events/2023/Building_Ideas_About_Justice_into_Policy_Research_Brochure.pdf",
    //     title: `30th National Conference on Communications (NCC 2024), will be jointly organized by IIT Madras and IIT Tirupati.`,
    //     img: '',
        // description: '',
        // dt: "28 Feb - 2 Mar",
    //     my: "Feb",
    //     glow: "no"
    // },


    {
        venue: 'IIT Tirupati',
        link: "https://files.iittp.ac.in/pdfs/events/2023/Building_Ideas_About_Justice_into_Policy_Research_Brochure.pdf",
        title: `Building Ideas about Justice into Policy Research`,
        description: 'Public policy research has a clear opportunity to provide insight into issues of inequality and justice across a wide range of specific topical areas.In this workshop, students will explore how they might think about including considerations of inequality or justice into their independent research',
        img: 'https://files.iittp.ac.in/images/events/HSS2023.png',
        dt: "3 - 4",
        my: "Nov",
        duration: '2 days',
    },
    {
        venue: 'IIT Tirupati',
        link: "https://files.iittp.ac.in/pdfs/events/2023/flyer_Akash_IIT_event_physics_4 Nov 2023.pdf",
        title: `Department of Physics is conducting an event "AKASH: the infinite possibilities"`,  
        description: ' a one day seminar series   dedicated to India space science and exploration.  | To live Telecast https://www.youtube.com/watch?v=Wi6grSZJQZw .  Welcome to "Akash: Infinite Possibilities" - a one day seminar series dedicated to Indias space science and exploration.',
        img: 'https://files.iittp.ac.in/images/events/AKASH2023.png',
        dt: "4",
        my: "Nov",
        duration: '',
    },
  
    // {
    //     link: "https://iittp.ac.in/ncc2024/",
    //     title: `30th National
    //     Conference on Communications (NCC 2024), will be jointly organized by IIT Madras and IIT
    //     Tirupati.`,
    //     img: '',
        // description: '',
        // dt: "28 - 2",
    //     my: "Feb - Mar"
    // },
    {
        venue: 'IIT Tirupati',
        link: "https://iittp.ac.in/camost/camostcs.php",
        title: `CAMOST-G20-S20
        Consortium Webinar Series on  "Disruptive Science and Technologies"`,
        description: '',
        img: '',
        dt: "16 - 21",
        my: "Aug - Oct",
        duration: '',
    },
    {
        venue: 'IIT Tirupati',
        link: "https://pfam29.com/workshop.html",
        title: `Two
        Pre-Conference Workshops are being organized on Additive
        Manufacturing and Semiconductor Packaging on 5th September 2023 at IIT
        Tirupati.`,
        description: '',
        img: '',
        dt: "5",
        my: "Sep",
        duration: '',
    },
    {
        venue: 'IIT Tirupati',
        link: "https://pfam29.com/workshop.html",
        title: `29th International Conference on Processing and Fabrication of Advanced Materials (29th PFAM 2023`,
        description: '',
        img: '',
        dt: "6 - 8",
        my: "Sep",
        duration: '',
    },
    {
        venue: 'IIT Tirupati',
        link: "https://iittp.ac.in/#DMSC",
        title: `Indo-German Workshop on Data Mathematics and Scientific Computing `,
        description: '',
        img: '',
        dt: "8",
        my: "Sep",
        duration: '',
    },
    {
        venue: 'IIT Tirupati',
        link: "https://files.iittp.ac.in/pdfs/events/2023/Start-ups_funding_eco-system.jpg",
        title: `IIT Tirupati - Institution’s Innovation Council E-Cell jointly organizing workshop on the Theme "Start-ups funding eco-system". `,
        description: '',
        img: '',
        dt: "30",
        my: "Aug",
        duration: '',
    },
    {
        venue: 'IIT Tirupati',
        link: "https://files.iittp.ac.in/pdfs/events/2023/IPR_Workshop_19_AUG.jpg",
        title: `IPR workshop on "Innovation, Invention, and Creativity" .`,
        description: '',
        img: '',
        dt: "19",
        my: "Aug",
        duration: '',
    },
    {
        venue: 'IIT Tirupati',
        link: "https://files.iittp.ac.in/pdfs/events/2023/The Philosophy of (Auto) Biography-- Experience and (Self)Representation.pdf",
        title: `GIAN course on "Body Politics: The Philosophy of Autobiography Through
        Literature".`,
        description: '',
        img: '',
        dt: "18 - 22",
        my: "Jul",
        duration: '',
    },
    {
        venue: 'IIT Tirupati',
        link: "https://files.iittp.ac.in/pdfs/events/2023/Pre Incubation Idea third call_Extended.pdf",
        title: `Pre Incubation Contest on Call For "Technical Business Ideas 2023".`,
        description: '',
        img: '',
        dt: "26",
        my: "Jul",
        duration: '',
    },
    {
        venue: 'IIT Tirupati',
        link: "https://iittp.ac.in",
        title: `NIRM
        Lecture Series on
        "Role of Rock Engineering in Nation Building" .`,
        description: '',
        img: '',
        dt: "29",
        my: "Jul",
        duration: '',
    },
    {
        venue: 'IIT Tirupati',
        link: "https://files.iittp.ac.in/pdfs/events/2023/Finite_Element_Methods-Brochure.pdf",
        title: `Five-Day
        Workshop on "Finite Element Methods- Theory and Practice (Ansys)", Department of
        Mechanical Engineering, IIT Tirupati.`,
        description: '',
        img: '',
        dt: "19 - 23",
        my: "Jun",
        duration: '',
    },
    {
        venue: 'IIT Tirupati',
        link: "https://files.iittp.ac.in/pdfs/events/2023/Brochure-TFTS.pdf",
        title: `Short Term Course on "Traffic Flow Theory and Simulation" .`,
        description: '',
        img: '',
        dt: "12 - 27",
        my: "Jun",
        duration: '',
    },
    {
        venue: 'IIT Tirupati',
        link: "https://files.iittp.ac.in/pdfs/events/2023/IPR Day Brochure.jpg",
        title: ` Workshop on "Role of Intellectual Property Rights for Academia"`,
        description: '',
        img: '',
        dt: "17",
        my: "May",
        duration: '',
    },
    {
        venue: 'IIT Tirupati',
        link: "https://files.iittp.ac.in/pdfs/events/2023/8th%20Institute%20Day%20Invitation-%20IIT%20Tirupati.pdf",
        title: `8th Institute Day Celebration on 6th April 2023. The Chief Guest for the occasion is Prof Sudhir K Jain, Vice-Chancellor of Banaras Hindu University."`,
        description: '',
        img: '',
        dt: "6",
        my: "April"
    },
    {
        venue: 'IIT Tirupati',
        link: "https://files.iittp.ac.in/pdfs/events/2023/8th Institute Day Invitation- IIT Tirupati.pdf",
        title: `Workshop on "Computational and Applied Mathematics"`,
        description: '',
        img: '',
        dt: "14-15",
        my: "April",
        duration: '',
    },
    {
        venue: 'IIT Tirupati',
        link: "https://files.iittp.ac.in/pdfs/events/2023/8th Institute Day Invitation- IIT Tirupati.pdf",
        title: `TIRUTSAVA-2023 Annual Techno-Cultural Fest of IIT Tirupati"`,
        description: '',
        img: '',
        dt: "31-2 ",
        my: "April",
        duration: '',
    },
    {
        venue: 'IIT Tirupati',
        link: "https://files.iittp.ac.in/pdfs/events/2023/Sciencee%20Hack%203.0%20Updated%20Poster.pdf",
        title: `NSS Organising
        an online project competition on  Science Hack 3.0  from 6th Feb to 31 March, 2023. `,
        description: '',
        img: '',
        dt: "31 - 2",
        my: "Mar - April",
        duration: '',
    },
    {
        venue: 'IIT Tirupati',
        link: "https://files.iittp.ac.in/pdfs/events/2023/Next Generation Mapping of Built-up Infrastructure and Assets - Opportunities and Challenges_Brochure.pdf",
        title: `One-day workshop on  "Next Generation Mapping of Built-up
        Infrastructure and Assets - Opportunities and Challenges"`,
        description: '',
        img: '',
        dt: "21",
        my: "Mar",
        duration: '',
    },
    {
        venue: 'IIT Tirupati',
        link: "https://files.iittp.ac.in/pdfs/events/2023/Women's Day Brochure.pdf",
        title: `Women's Day Celebrations`,
        description: '',
        img: '',
        dt: "11 - 13",
        my: "Mar",
        duration: '',
    },
    {
        venue: 'IIT Tirupati',
        link: "https://files.iittp.ac.in/pdfs/events/2023/IIT Tirupati __ T-Hub Final 3_page-0001.jpg",
        title: `One-day workshop on  "BEYOND THE INNOVATION"`,
        description: '',
        img: '',
        dt: "16",
        my: "Mar",
        duration: '',
    },
    {
        venue: 'IIT Tirupati',
        link: "https://files.iittp.ac.in/pdfs/events/2023/Water 2023_Indo-Canadian Symposium.pdf",
        title: `Indo-Canadian symposium on "Water Management: Sustainability &amp; Impact
        of Climate Change" `,
        description: '',
        img: '',
        dt: "6 - 7",
        my: "Mar"
    },
    {
        venue: 'IIT Tirupati',
        link: "https://iittp.ac.in/#ek",
        title: `Ek
        Bharat Shreshtha Bharat- Yuva Sangam ( Exposure Visit of Youth to Various States of
        India)`,
        description: '',
        img: '',
        dt: "8",
        my: "Feb",
        duration: '',
    },
    {
        venue: 'IIT Tirupati',
        link: "https://files.iittp.ac.in/pdfs/events/2023/MPP-Flyer.pdf",
        title: `Open
        House for Prospective Applicants Master of Public Policy `,
        description: '',
        img: '',
        dt: "24",
        my: "Feb",
        duration: '',
    },
    {
        venue: 'IIT Tirupati',
        link: "https://iittp.ac.in/#F4SAC",
        title: `Foundry 4.0
        Innovation Workshop and Foundry Visit `,
        description: '',
        img: '',
        dt: "24 - 25",
        my: "Feb",
        duration: '',
    },
    {
        venue: 'IIT Tirupati',
        link: "https://files.iittp.ac.in/pdfs/events/2023/Science Day Celebration.png",
        title: `National Science Day
        Celebration - 2023`,
        description: '',
        img: '',
        dt: "25",
        my: "Feb",
        duration: '',
    },
    {
        venue: 'IIT Tirupati',
        link: "https://files.iittp.ac.in/pdfs/events/2023/Expert_Talk_10-02-23.jpg",
        title: `Expert Talk by Mr. Hemanth Satyanarayana, Founder &amp; CEO, IMAGINATE On
        "An Entrepreneur's Trysts with Virtual and Augmented Reality and Enterprise
        Sales"`,
        description: '',
        img: '',
        dt: "10",
        my: "Feb",
        duration: '',
    },
    {
        venue: 'IIT Tirupati',
        link: "https://files.iittp.ac.in/pdfs/events/2023/IIC 5.0 Brochure.png",
        title: `Orientation Session of the Institutions’ Innovation Council (IIC5.0)
        Features`,
        description: '',
        img: '',
        dt: "11",
        my: "Jan",
        duration: '',
    },
    {
        venue: 'IIT Tirupati',
        link: "https://files.iittp.ac.in/pdfs/workshop/2023/Agenda - Second Roundtable on Sustainability.pdf",
        title: `The Second
        Roundtable on Sustainability Crisis`,
        description: '',
        img: '',
        dt: "8",
        my: "Jan",
        duration: '',
    },
    {
        venue: 'IIT Tirupati',
        link: "https://files.iittp.ac.in/pdfs/workshop/2022/ASM Event Invitation_183832.pdf",
        title: `ASM IIT
        Tirupati Chapter - Department of Mechanical Engineering: Technical Talk by Prof. T S
        Srivatsan`,
        description: '',
        img: '',
        dt: "5",
        my: "Jan",
        duration: '',
    }
]

export default EventsArray2023;